import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import getClientInstance from "../../config/apollo-client";
import CONSULTATION_ASSIGNED_ATTENDEES_QUERY from "../queries/consultation-assigned-attendees.graphql";
import { Title } from "../components";
import { I18n, translate } from "@td/shared_utils";
import { ParticipantItem } from "../components/Participants";
import ReactTooltip from "react-tooltip";

const attendeeSelector = (roleCd) => (attendee) => attendee.roleCd === roleCd;
const attendeeStatusSelector = (id, roleCd) => (attendee) => (
  parseInt(attendee.id) === parseInt(id) && attendee.roleCd.replace(/^(tdoc\_)/, "") === roleCd
);

const Participants = React.memo(({ member, provider, attendeeStatuses, consultationId, visitType }) => {
  const apolloClient = getClientInstance();
  
  const [attendees, setAttendees] = useState([]);

  useEffect(() => {
    apolloClient.query({
      query: CONSULTATION_ASSIGNED_ATTENDEES_QUERY,
      variables: { consultationId },
    }).then(({ data: { consultation: { consultationInteraction: { assignedPersonRelationships }}}}) => {
      setAttendees(
        assignedPersonRelationships.map(({ roleCd, assignedActor: { id, name }}) => ({
          id,
          name,
          roleCd,
        }))
      );
    });
  }, [consultationId]);

  const attendeeMa = attendees.find(attendeeSelector("ATTENDEEROLE_MA"));
  const attendeeRn = attendees.find(attendeeSelector("ATTENDEEROLE_RN"));

  return (
    <React.Fragment>
      <Title>
        <I18n scope="call_details" text="participants" />
      </Title>

      <ParticipantItem
        label={translate(null, "call_details.participant_labels", "member")}
        href={Routes.member_path(member.id)}
        participant={{ name: member.fullName }}
        status={
          attendeeStatuses.find(attendeeStatusSelector(member.id, "member"))
        }
        visitType={visitType}
      />
      <ParticipantItem
        label={translate(null, "call_details.participant_labels", "provider")}
        href={Routes.provider_path(provider.id)}
        participant={{ name: provider.fullName }}
        status={
          attendeeStatuses.find(attendeeStatusSelector(provider.id, "provider"))
        }
        visitType={visitType}
      />
      {attendeeMa && (
        <ParticipantItem
          label={translate(null, "call_details.participant_labels", "pre_consult")}
          participant={{ name: attendeeMa.name }}
          status={
            attendeeStatuses.find(attendeeStatusSelector(attendeeMa.id, "admin_ma"))
          }
          visitType={visitType}
        />
      )}
      {attendeeRn && (
        <ParticipantItem
          label={translate(null, "call_details.participant_labels", "post_consult")}
          participant={{ name: attendeeRn.name }}
          status={
            attendeeStatuses.find(attendeeStatusSelector(attendeeRn.id, "admin_rn"))
          }
          visitType={visitType}
        />
      )}

      <ReactTooltip />
    </React.Fragment>
  );
});

Participants.displayName = "Participants";

Participants.propTypes = {
  member: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
  attendeeStatuses: PropTypes.array.isRequired,
  consultationId: PropTypes.number.isRequired,
  visitType: PropTypes.string.isRequired,
};

export default Participants;
